import React from 'react';
import data from './greeting.json';

const { viewBox, groups } = data;

// Paths, not <text>: Safari does not shape the स्ते conjunct correctly inside
// SVG text, it breaks the ligature apart and leaves dotted circles behind.
// Generated by scripts/gen_greeting.py.
//
// width/height only keep the intrinsic size small. Without them an SVG defaults
// to 300px, which is wider than the name on a phone and would then drive the
// fit-content width of .name-line.
function Greeting() {
  return (
    <div className="greeting">
      <svg
        className="greeting-svg"
        viewBox={viewBox}
        width="20"
        height="9"
        preserveAspectRatio="xMidYMid meet"
        role="img"
        aria-label="नमस्ते (namaste)"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="scale(1,-1)">
          {groups.map((paths, group) =>
            paths.map((path, i) => (
              <path
                key={`${group}-${i}`}
                className="letter"
                d={path.d}
                transform={`translate(${path.dx},${path.dy})`}
                style={{
                  // the real outline length, so one dash covers the stroke
                  strokeDasharray: path.len,
                  strokeDashoffset: path.len,
                  animationDelay: `${group}s`,
                }}
              />
            ))
          )}
        </g>
      </svg>
    </div>
  );
}

export default Greeting;
